<template>
  <div class="thumbsnav">
    <div class="thumbcont">
      <carousel
        :scrollPerPage="false"
        :perPageCustom="[[480, 3],
        [510, 4],
        [630, 5],
        [750, 6],
        [970, 7],
        [990, 8],
        [1110, 9],
        [1230, 10],
        [1350, 11]]"
        :mouse-drag="true"
        :navigateTo="$store.state.currentStep-1"
        :paginationEnabled="false"
      >
        <slide
          v-for="(item, key) in $store.state.items"
          :key="key"
          :class="'thumb'+thumbClass(key)+' num'+(key+1)"
          :data-index="key"
          @slideclick="gotoSlide(key)"
        >
          <img
            :src="'./images/' + item[1].thumb"
            :alt="item[0]"
          >
          <div class="filter"></div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'ThumbsNavComponent',
  props: {

  },
  data() {
    return {
    };
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {
    gotoSlide(key) {
      this.$store.state.currentStep = key + 1;
    },
    thumbClass(key) {
      if (this.$store.state.currentStep === (key + 1)) {
        return ' current';
      } return '';
    },
  },
  mounted() {
  },
  computed: {
    ...mapState(['items', 'currentStep']),
  },
  watch: {
    currentStep(newValue, oldValue) {
      if (newValue !== oldValue) {
        return newValue;
      }
      return oldValue;
    },
  },
};
</script>

<style scoped lang="css">
.thumbsnav {
  width: calc(100% - 30px);
  margin: 0 auto;
  height: 120px;
  position: relative;
}
.thumbcont {
}
.thumb {
  cursor: pointer;
  height: 120px;
  width: 120px;
  transition: all 1s;
  position: relative;
}
.thumb img {
  position: relative;
  z-index: 1;
  width: 100%;
}
.thumb.current,
.thumb:hover {
  transform: scale(1.1);
  z-index: 2;
}
.filter {
  background-color: #e2af25;
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
}
.thumb:hover .filter {
  z-index: 2;
  opacity: 0.4;
}
@media screen and (max-width: 767px) {
  .thumbsnav {
    display: none;
  }
}
</style>
<style>
.VueCarousel-wrapper {
  overflow: visible;
}
</style>
